const historyAlert = (e) => {
  // most browsers, the default message is displayed instead of this value
  e.returnValue = '入力内容が失われます。ページを移動しますか？';
};

export const addHistoryAlert = () => {
  window.addEventListener('beforeunload', historyAlert);
};

export const removeHistoryAlert = () => {
  window.removeEventListener('beforeunload', historyAlert);
};
